import React from 'react';
import { type IIconProps } from '../../dm/icons.js';

export const SmallCapsIcon = ({ className, color, size }: IIconProps) => {
  return (
    <svg
      version="1.0"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      enableBackground="new 0 0 64 64"
      xmlSpace="preserve"
      fill={color}
      className={className}
      width={size}
      height={size}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
      <g id="SVGRepo_iconCarrier">
        <g>
          <polyline fill="none" stroke={color} strokeWidth="2" strokeMiterlimit="10" points="38,51 23,9 22,9 7,51 " />
          <line fill="none" stroke={color} strokeWidth="2" strokeMiterlimit="10" x1="33" y1="37" x2="12" y2="37" />
        </g>
        <path
          fill="none"
          stroke={color}
          strokeWidth="2"
          strokeMiterlimit="10"
          d="M44,34c0,0,1.5-2,5.5-2s5.5,3,5.5,5s0,10,0,10 s0,3,2.5,3"
        />
        <path
          fill="none"
          stroke={color}
          strokeWidth="2"
          strokeMiterlimit="10"
          d="M55,40h-5c0,0-7,0-7,5s4,5,5,5s7,0,7-7"
        />
      </g>
    </svg>
  );
};
